/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/**
 * @author Shalini
 * @name BulkUploadHistory
 * @desc File Upload history component
 */
import React from 'react';
import clsx from 'clsx';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import styles from './BulkUpload.module.css';
import TableIcons from '../TableIcons';
import ModalDialog from '../ModalDialog';
import ErrorListComponent from './ErrorListComponent';
import { getUploadedPercent } from './OngoingUploads';
import { CustomToolTip } from '../ToolTips';
import Loader from '../Loader'; // import { ProcessingStatusTooltip, ErrorLabelTooltip, UpstreamSystemTooltip } from './constants';

import { loadLangCommon } from '../LocalizeLang';
import enData from './lang/en.json';
import esData from './lang/es.json';
import cmnData from './lang/cmn.json';
import Message from '../Message';
import { MaterialUiTable, MaterialUiIcons, MaterialUiCore } from '@gscope-mfe/common-libs';
import { Services, AppUtils } from '@gscope-mfe/app-bridge';
import frData from './lang/fr.json';

const MaterialTable = MaterialUiTable.default,
    RefreshRoundedIcon = MaterialUiIcons.RefreshRounded,
    { TablePagination } = MaterialUiCore,
    { bulkUploadHistory, getDownStreamMapping, downloadOriginalFile, downloadSuccessReport } = Services;
export const renderTitleWithTooltip = (title, tooltipData) => (
    <CustomToolTip title={tooltipData} placement={'top'}>
        <span>{title}</span>
    </CustomToolTip>
);
/**
 * @name renderUploadStatus
 * @desc Renders the upload status
 * @param {String} status
 * @param {Object} summary
 */

export const renderUploadStatus = (status, summary, trans) => {
    if (status === 'F') return <span className="statusLabel statusLabelRed">{trans('bulkUpload.failed')}</span>;
    if (status === 'Q') return <span className="statusLabel statusLabelOrange">{trans('bulkUpload.queuing')}</span>;

    if (status === 'S') {
        if (summary.total === 0) {
            return <span className="statusLabel statusLabelRed">{trans('bulkUpload.recordsNotFound')}</span>;
        }

        if (summary.processed < summary.total) {
            return (
                <span className="statusLabel statusLabelOrange">
                    {trans('bulkUpload.processing')} {getUploadedPercent(summary)}%
                </span>
            );
        }

        return <span className="statusLabel statusLabelGreen">{trans('bulkUpload.completed')}</span>;
    }
};
export const downloadFile = async (transactionId, fileName) => {
    const resFile = await downloadOriginalFile(transactionId);
    const url = window.URL.createObjectURL(new Blob([resFile.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

export const downloadSuccessFile = async (transactionId) => {
    const SUCCESS_DATA_FILE_NAME = 'Success_data.csv';
    const resSuccessFile = await downloadSuccessReport(transactionId);
    const url = window.URL.createObjectURL(new Blob([resSuccessFile.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', SUCCESS_DATA_FILE_NAME);
    link.download = SUCCESS_DATA_FILE_NAME;
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

const BulkUploadHistory = (props) => {
    const history = useHistory();
    const [uploadHistory, setUploadHistory] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState({});
    const [downstreamData, setDownstreamData] = React.useState({});

    const handleClose = () => setOpen(false);

    const trans = loadLangCommon(
        [
            ['en', enData],
            ['es', esData],
            ['fr', frData],
            ['cmn', cmnData],
        ],
        'bulkUpload',
    );
    let showTIDcolumn = false;
    let bulkUpdateHistory = false;
    if (props.location && props.location.state) {
        showTIDcolumn = props.location.state.showTIDcolumn;
        bulkUpdateHistory = props.location.state.bulkUpdateHistory;
    }
    const { userInfo, setBreadCrumbArr, queryParam = {} } = AppUtils.get();
    let columns = [
        {
            field: 'transactionId',
            title: '',
            render: () => null,
            headerStyle: {
                display: 'none',
            },
            cellStyle: {
                display: 'none',
            },
            searchable: true,
        },
        {
            field: 'fileName',
            title: trans('bulkUpload.fileName'),
            searchable: false,
        },
        {
            field: 'fileNameSearch',
            title: '',
            render: () => null,
            searchable: true,
        },
        {
            field: 'uploadDate',
            title: trans('bulkUpload.uploadDateTime'),
            searchable: true,
        },
        {
            field: 'service',
            title: renderTitleWithTooltip(
                trans('bulkUpload.upstreamSystem'),
                trans('bulkUpload.constUpstreamSystemTooltip'),
            ),
            searchable: true,
        },
        {
            field: 'status',
            title: renderTitleWithTooltip(
                trans('bulkUpload.processingStatus'),
                trans('bulkUpload.constProcessingStatusTooltip'),
            ),
            searchable: true,
        },
        {
            field: 'error',
            title: renderTitleWithTooltip(trans('bulkUpload.Error'), trans('bulkUpload.constErrorLabelTooltip')),
        },
        {
            field: 'success',
            title: trans('bulkUpload.Success'),
            searchable: false,
        },
    ];

    if (showTIDcolumn) {
        columns = [
            {
                field: 'transactionId',
                title: trans('bulkUpload.transactionId'),
                searchable: true,
            },
            {
                field: 'fileName',
                title: trans('bulkUpload.fileName'),
                searchable: false,
            },
            {
                field: 'fileNameSearch',
                title: '',
                render: () => null,
                searchable: true,
            },
            {
                field: 'uploadDate',
                title: trans('bulkUpload.uploadDateTime'),
                searchable: true,
            },
            {
                field: 'service',
                title: renderTitleWithTooltip(
                    trans('bulkUpload.upstreamSystem'),
                    trans('bulkUpload.constUpstreamSystemTooltip'),
                ),
                searchable: true,
            },
            {
                field: 'status',
                title: renderTitleWithTooltip(
                    trans('bulkUpload.processingStatus'),
                    trans('bulkUpload.constProcessingStatusTooltip'),
                ),
                searchable: true,
            },
            {
                field: 'error',
                title: renderTitleWithTooltip(trans('bulkUpload.Error'), trans('bulkUpload.constErrorLabelTooltip')),
            },
        ];
    }

    if (bulkUpdateHistory) {
        columns.push({ field: 'uploadDesc', title: trans('bulkUpload.comments'), searchable: true });
    }

    const searchableCols = columns.filter((c) => c.searchable).map((c) => c.field); // Only single column will be searcheable from url due to material-table limitations

    const [searchText, setSearchText] = React.useState(
        searchableCols.filter((c) => c in queryParam).reduce((acc, c) => acc || queryParam[c], ''),
    );
    /**
     * @name updateDownstreamMapping
     * @desc Fetched the list of downstream and maps it to the current data
     */

    const updateDownstreamMapping = async () => {
        setIsLoading(true);
        const { data } = await getDownStreamMapping();
        setDownstreamData(data);
        setIsLoading(false);
    };
    /**
     * @name fetchHistoryList
     * @desc Fetches the list of history for a user
     */

    const fetchHistoryList = async () => {
        setIsLoading(true);
        const { data } = await bulkUploadHistory(userInfo.loggedInUserName, bulkUpdateHistory);
        setIsLoading(false);

        if (data.payload) {
            setUploadHistory(data.payload.history.filter((item) => item.fileName));
        }
    };
    /**
     * @name showErrorModal
     * @desc Show the error modal
     * @param {String} fileName
     * @param {String} transactionId
     */

    const showErrorModal = (fileName, transactionId, status) => {
        setSelectedFile({ ...selectedFile, fileName, transactionId, status });
        setOpen(true);
    };
    /**
     * @name createData
     * @desc Creates Data for table
     */

    const createData = ({
        uploadDate,
        fileName,
        service,
        status,
        summary,
        transactionId,
        blobReferenceName,
        uploadDesc,
        success,
    }) => ({
        transactionId,
        uploadDate: moment(uploadDate).format('MMM Do YYYY, HH:mm'),
        fileName: blobReferenceName ? (
            <span className={styles.history_errorLabel} onClick={() => downloadFile(transactionId, fileName)}>
                {fileName}
            </span>
        ) : (
            fileName
        ),
        fileNameSearch: fileName,
        service: service ? downstreamData[service] || service.toUpperCase() : service,
        status: renderUploadStatus(status, summary, trans),
        error:
            summary.errors === 0 ? (
                '--'
            ) : (
                <span
                    className={styles.history_errorLabel}
                    onClick={() => showErrorModal(fileName, transactionId, status)}
                >
                    {summary.errors} {trans('bulkUpload.errors')}
                </span>
            ),
        uploadDesc,
        success: (
            <span className={styles.history_errorLabel} onClick={() => downloadSuccessFile(transactionId)}>
                {summary.processed - summary.errors} {trans('bulkUpload.Success')}
            </span>
        ),
    });

    const rows = uploadHistory.map((file) => createData(file));
    React.useEffect(() => {
        updateDownstreamMapping();
        fetchHistoryList();
        setBreadCrumbArr([]);
    }, []);
    return (
        <div className={styles.history_tableContainer}>
            <Loader show={isLoading} />
            <div className={styles.history_backBtnContainer}>
                <button
                    type="button"
                    className={clsx('primaryBtn primaryBtnEnabled', styles.history_backBtn)}
                    onClick={() => history.goBack()}
                >
                    <span className="sct-icons icon-Arrow-Left-18" />
                    <span className={styles.history_btnText}>{trans('bulkUpload.back')}</span>
                </button>
                <span className={styles.history_warningMsg}>
                    <Message variant="warning" style="outlined" message={trans('bulkUpload.refreshNoteMsg')} />
                </span>
            </div>
            <MaterialTable
                columns={columns}
                data={rows}
                title={`${
                    bulkUpdateHistory ? trans('bulkUpdate.historyOfUpdates') : trans('bulkUpload.historyOfUploads')
                } (${uploadHistory.length} ${trans('bulkUpload.resultsFound')})`}
                icons={TableIcons}
                onSearchChange={setSearchText}
                options={{
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 30, 40, 50, 100],
                    showEmptyDataSourceMessage: false,
                    emptyRowsWhenPaging: false,
                    thirdSortClick: false,
                    headerStyle: {
                        backgroundColor: 'var(--backgroundGray)',
                        color: 'var(--black)',
                        marginLeft: '0px',
                    },
                    searchText,
                }}
                localization={{
                    toolbar: {
                        searchPlaceholder: `${trans('bulkupload.search')}`,
                    },
                }}
                actions={[
                    {
                        icon: RefreshRoundedIcon,
                        tooltip: trans('bulkUpload.refreshProcessingStatus'),
                        isFreeAction: true,
                        onClick: () => fetchHistoryList(),
                    },
                ]}
                components={{
                    Pagination: (props) => {
                        const newProps = {
                            ...props,
                            labelRowsPerPage: trans('bulkUpload.itemsPerPage'),
                            SelectProps: {
                                inputProps: {
                                    'aria-label': trans('bulkUpload.itemsPerPage'),
                                },
                            },
                        };
                        return (
                            <TablePagination
                                style={newProps.style}
                                rowsPerPageOptions={newProps.rowsPerPageOptions}
                                rowsPerPage={+newProps.rowsPerPage}
                                colSpan={newProps.colSpan}
                                count={newProps.count}
                                page={+newProps.page}
                                SelectProps={newProps.SelectProps}
                                onChangePage={newProps.onChangePage}
                                icons={newProps.icons}
                                onChangeRowsPerPage={newProps.onChangeRowsPerPage}
                                labelRowsPerPage={newProps.labelRowsPerPage}
                                labelDisplayedRows={({ from, to, count }) => {
                                    return '' + from + '-' + to + ` ${trans('bulkUpload.of')} ` + count;
                                }}
                            />
                        );
                    },
                }}
            />
            <ModalDialog
                title={
                    <div>
                        {trans('bulkUpload.errorReport')} {selectedFile.fileName}
                    </div>
                }
                open={open}
                handleClose={handleClose}
            >
                <ErrorListComponent
                    bulkUpdateHistory={bulkUpdateHistory}
                    transactionId={selectedFile.transactionId}
                    status={selectedFile.status}
                    trans={trans}
                />
            </ModalDialog>
        </div>
    );
};

export default BulkUploadHistory;
